import { useSelector } from "react-redux";
import { useGetBooksQuery } from "../../features/api/apiSlice";
import Book from "./Book";

export default function Books() {
  const { data: books, isLoading, isError } = useGetBooksQuery();
  const { filter, search } = useSelector((state) => state.filter);

  const handleFilter = (book) => {
    switch (filter) {
      case "Featured":
        return book.featured;
      default:
        return true;
    }
  };
  const handleSearch = (book) =>
    book.name.toUpperCase().includes(search.toUpperCase());

  // decide what to render
  let content = null;
  if (isLoading) content = <div>Loading...</div>;
  if (!isLoading && isError) content = <div style={{color:"red"}}>There was an error</div>;
  if (!isLoading && !isError && books?.length === 0)
    content = <h1>No books found!</h1>;
  if (!isLoading && !isError && books?.length > 0)
    content = books
      .filter(handleFilter)
      .filter(handleSearch)
      .map((book) => <Book key={book.id} book={book} />);

  return (
    <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
      {content}
    </div>
  );
}
